import * as React from 'react'
import { translation } from 'easit--localization';

export const TicketHeader: React.FC = () => {
    return (
        <>
            <div className="combination-name px-2 text-left">
                {translation().combination}
            </div>
            <div className="rate-value text-center ">
                {translation().rate}
            </div>
            <div className="stake-value text-center">
                {translation().stake}
            </div>
            <div className="prize-potential text-center">
                {translation().eventual_win}
            </div>
        </>
    );
};
